// src/utils/models/switchModel.js

export const SUPPLY_TYPES = {
  LUZ: 'luz',
  GAS: 'gas'
};

export const SUPPLY_TYPE_LABELS = {
  luz: 'Luz',
  gas: 'Gas'
};

export const createSwitch = (data) => ({
  id: data.id || null,
  switchClientId: data.switchClientId || '',
  switchClientName: data.switchClientName || '',
  supplierId: data.supplierId || '',
  supplierName: data.supplierName || '',
  // Tipo de suministro (luz o gas)
  supplyType: data.supplyType || SUPPLY_TYPES.LUZ,
  // Dirección seleccionada
  selectedAddress: data.selectedAddress || null, // Índice de la dirección
  addressStreet: data.addressStreet || '',
  addressCity: data.addressCity || '',
  addressCups: data.addressCups || '',
  addressCupsGas: data.addressCupsGas || '',
  addressReferenciaCatastral: data.addressReferenciaCatastral || '',
  fechaEntrada: data.fechaEntrada || '',
  fechaSalida: data.fechaSalida || '',
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: data.updatedAt || new Date().toISOString(),
  isActive: true
});